import { render, staticRenderFns } from "./workflow-resources-list.vue?vue&type=template&id=f041084c&scoped=true"
import script from "./workflow-resources-list.vue?vue&type=script&lang=js"
export * from "./workflow-resources-list.vue?vue&type=script&lang=js"
import style0 from "./workflow-resources-list.vue?vue&type=style&index=0&id=f041084c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f041084c",
  null
  
)

export default component.exports